import { Reveal } from "./motion";
import { MANIFESTO } from "@/data";

export const Manifesto = () => (
  <section id="philosophy" className="py-24 sm:py-36 bg-[#1A1C1A] scroll-mt-24 relative overflow-hidden" data-testid="philosophy">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="overline text-[#E8A87C] mb-6">Philosophy of Care</p>
        <blockquote className="font-serif-display font-light text-3xl sm:text-5xl lg:text-6xl text-[#FDFBF7] leading-[1.15] tracking-tight max-w-4xl">
          “Compassion, precision, and <span className="italic text-[#E8A87C]">evidence-based care</span> form the foundation of every treatment decision.”
        </blockquote>
      </Reveal>

      <div className="mt-20 sm:mt-28 space-y-16 sm:space-y-24">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.05}>
            <div className="grid lg:grid-cols-12 gap-6 lg:gap-10 items-start border-t border-white/10 pt-10">
              <div className="lg:col-span-4">
                <span className="font-serif-display font-light text-7xl sm:text-8xl text-[#B9735A] leading-none">
                  {m.n}
                </span>
              </div>
              <div className="lg:col-span-8">
                <h3 className="font-serif-display text-3xl sm:text-4xl text-[#FDFBF7] mb-4">{m.title}</h3>
                <p className="text-[#c9c7c1] text-base sm:text-lg leading-relaxed max-w-2xl">{m.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
